import { api } from './client';
import type { Shoot } from './types';

// Normaliserar två tänkbara svarsformer:
//   1) Array direkt: [shoot, shoot, …]
//   2) Wrapped:      { shoots: [shoot, …] }
function unwrapShoots(payload: Shoot[] | { shoots: Shoot[] }): Shoot[] {
  if (Array.isArray(payload)) return payload;
  return payload.shoots ?? [];
}

export async function listShoots(): Promise<Shoot[]> {
  const data = await api.get<Shoot[] | { shoots: Shoot[] }>('/shoots');
  return unwrapShoots(data).map(normalizeShoot);
}

export async function getShoot(id: string): Promise<Shoot> {
  const data = await api.get<Shoot | { shoot: Shoot }>(`/shoots/${id}`);
  const shoot = 'shoot' in (data as { shoot?: Shoot }) ? (data as { shoot: Shoot }).shoot : (data as Shoot);
  return normalizeShoot(shoot);
}

// Konsoliderar snake_case och camelCase till camelCase. Behåller obehandlade
// fält ifall vi behöver dem.
export function normalizeShoot(shoot: Shoot): Shoot {
  return {
    ...shoot,
    imageCount: shoot.imageCount ?? shoot.image_count,
    coverImageId: shoot.coverImageId ?? shoot.cover_image_id ?? null,
    favoriteCount: shoot.favoriteCount ?? shoot.favorite_count,
    collageImageIds: shoot.collageImageIds ?? shoot.collage_image_ids,
    createdAt: shoot.createdAt ?? shoot.created_at,
    date: shoot.date ?? shoot.shootDate,
  };
}
